export default __webpack_public_path__ + "static/media/workflow.f2a731f4.svg";